import {store} from '@redux/store';
import {
    getGoogleAnalyticsEventProperties,
    getSegmentEventProperties
} from './services/trackingPropertiesService';
import selfGuidedTourSlice from './redux/slices';
import ModalStep from './enums/modalStep';
import SelfGuidedTourModal from './components/selfGuidedTourModal';
import { 
    selectModalStep, 
    selectQuestionResponses,
    selectSelectedSlot,
    selectTourableSpecs
} from './redux/selectors';
import { selectModal$ } from './redux/observables';
import {getStoredUserData } from './services/userService'; 
import {
    getTourableSpecsByCommunityId$,
    getTourableSpecsByPlanId$
} from './services/tourableSpecsFetchService';

const { actions: selfGuidedActions, reducer } = selfGuidedTourSlice;

store.injectReducer('selfGuidedTour', reducer);

export {
    selfGuidedActions,
    ModalStep,
    getStoredUserData,
    selectModalStep,
    selectQuestionResponses,
    selectSelectedSlot,
    selectTourableSpecs,
    getTourableSpecsByCommunityId$,
    getTourableSpecsByPlanId$,
    selectModal$,
    getGoogleAnalyticsEventProperties,
    getSegmentEventProperties,
    SelfGuidedTourModal
};
